import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useInvalidateStorageInfo } from '../../api/hooks/useInvalidateStorageInfo'
import { useDiskStore } from '../../store/storeDisk'
import { useFilesStore } from '../../store/storeFiles'
import { useWrapperStore } from '../../store/storeWrapper'

export const FileDeleteDialog = ({ open, handleClose, filename, idEntity, file }) => {
    const { pathname } = useLocation()
    const {
        fileDelete,
        errorFileDelete,
        isLoadingFileDelete,
        fetchFilesUser,
        isDoneFileDelete,
        setIsDoneFileDelete,
    } = useFilesStore((state) => state)
    const { setStateNotification, setRefreshStorage } = useWrapperStore((state) => state)
    const { deleteFileOrFolder } = useDiskStore((state) => state)
    const invalidateQueries = useInvalidateStorageInfo()

    const handleClickDelete = async () => {
        if (pathname === '/disk') {
            await deleteFileOrFolder({ prefix: file.url?.split(file.user_uuid).pop() })
        } else {
            await fileDelete({ prefix: `/${idEntity}/${filename}` })
            await fetchFilesUser({ prefix: `/${idEntity}/` })
        }
        setRefreshStorage(true)
        invalidateQueries()
        handleClose()
    }

    useEffect(() => {
        if (errorFileDelete) {
            setStateNotification({ isOpen: true, text: errorFileDelete, isError: true })
        }
    }, [errorFileDelete])

    useEffect(() => {
        if (isDoneFileDelete) {
            setStateNotification({ isOpen: true, text: 'Файл успешно удален!', isError: false })
            setIsDoneFileDelete(false)
        }
    }, [isDoneFileDelete])

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: '500px',
                    },
                }}
                open={open}
                onClose={handleClose}>
                <DialogTitle>
                    {file.object_type === 'folder' ? 'Удалить папку?' : 'Удалить файл?'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {file.object_type === 'folder'
                            ? 'Папка и его содержимое будут удалены без возможности восстановления'
                            : 'Файл будет удален без возможности восстановления'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus variant="outlined" color="primary">
                        Отмена
                    </Button>
                    <Button
                        onClick={handleClickDelete}
                        color="error"
                        variant="outlined"
                        disabled={isLoadingFileDelete}>
                        Удалить
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
